<template>
  <div>
    <div v-if="['Switch'].includes(field.viewType)">
      <v-switch
        v-model="$props.value"
        readonly
        :label="field.label"
      />
    </div>
    <div v-else-if="listLabel">
      <div class="caption" v-text="field.label"></div>
      <div v-if="labels.length">
        <v-chip
          v-for="(label, i) in labels"
          :key="label"
          :color="textColor[i] || 'black'"
          label
          outlined
          class="mr-1 mt-1"
        >
          {{ label }}
        </v-chip>
      </div>
      <div v-else :class="`${color}--text`" class="subtitle-2">--</div>
    </div>
    <div v-else-if="field.showLabel === undefined || field.showLabel === true">
      <span :class="color !== 'black' ? `${color}--text` : ''" class="caption" v-text="field.label"></span>
      <div :class="`${color}--text`" class="subtitle-2" v-text="content"></div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'SimpleField',
  props: [
    'field', 'value', 'textColor'
  ],
  data () {
    return { color: this.textColor || 'black' };
  },
  computed: {
    labels () {
      if (this.field.viewType === 'ClientReferences' && this.value) {
        return this.value.map(context => `${context.iresa_id} | ${context.context === 'speedboat' ? 'Vacances' : (context.extraContextInfo ? context.extraContextInfo.name : '')}`);
      }
      if (this.field.viewType === 'Newsletters') {
        // Remove schema property
        delete this.value.__typename;
        const activeNewsletters = [];
        Object.keys(this.value).forEach(newsletter => {
          // If newsletter is active
          if (this.value[newsletter]) {
            activeNewsletters.push(this.findOptionLabel(newsletter, this.field.options));
          }
        });
        return activeNewsletters;
      }
      if (this.field.viewType === 'Select' && this.field.multivalued) {
        return this.value.map(v => this.findOptionLabel(v, this.field.options));
      }
      return [];
    },
    listLabel () {
      return ['ClientReferences', 'Newsletters'].includes(this.field.viewType) || (this.field.viewType === 'Select' && this.field.multivalued);
    },
    content () {
      // if no value
      if (!this.value) {
        return '--';
      }

      if (this.field.options) {
        return this.findOptionLabel(this.value, this.field.options);
      }

      if (this.field.viewType === 'Date Picker') {
        return this.formatDate(this.value);
      }

      return this.value;
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    findOptionLabel (value, options) {
      const item = options.find(x => x.value === value);
      if (item) {
        return item.text;
      }
      return value;
    }
  }
};
</script>
